/*
 * AW: JE bits
 * ---------------------------------------------------------------------------
 */
   
(function() {
'use strict';
  window.JE = window.JE || {};
  window.JE.jeInit = function ($) {
      
    //
    //function hideCollectiveHeaders() {
    //  $(".je-collective__header").hide();
    //  $(window).one('scroll', function () {
    //    window.scrollTo(0, 0);
    //  });
    //}
    //function showCollectiveHeaders() {
    //  $(".je-collective__header").show();
    //}
    //console.log("HASH " + window.location.hash);
    //if(window.location.hash != "") {
    //  hideCollectiveHeaders();
    //} else {
    //  showCollectiveHeaders();
    //}
    
    function selectPartnerHeading(hash) {
      $(".je-partner-heading").removeClass("selected");
      $(".je-partner2").removeClass("selected");
      $(".je-partner-heading[href='" + hash + "']").addClass("selected");
      $(".je-partner2[data-partner-heading='" + hash + "']").addClass("selected");
    }
    
    // controls partner heading tabs
    $(window).on("hashchange", function(){
      selectPartnerHeading(window.location.hash);
    });
    // on load
    if(window.location.hash != "") {
      selectPartnerHeading(window.location.hash);
    } else {
      const defaultSelectedHash = $(".je-partner-heading.selected").attr("href");
      selectPartnerHeading(defaultSelectedHash);
    }
    
    // TODO PRESSING BACK BREAKS IT
    
  } 
})();
